import { Box } from '@mui/material';
import { KpiCard } from './KpiCard';
import * as kpiState from '../../state';
import { useGetLogEntryCardsQuery, SectionUnitsEnum, LogCategory } from '@/__generated__/graphql';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { getIconNode } from './utils';
import { COLLECTION_NAMES } from '@/constants';
import * as globalState from '@/components/Analysis/state';
import { useGetPlatformId } from '@/hooks/useGetPlatformId';

export const KpiCards = () => {
  const selectedDeploymentIds = useAtomValue(kpiState.selectedDeploymentIds);
  const platformId = useGetPlatformId();
  const selectedWorkpackTypes = useAtomValue(kpiState.selectedWorkpackTypes);
  const selectedWbsFilter = useAtomValue(kpiState.selectedWbsFilter);
  const unitSystem = useAtomValue(globalState.unitSystem);
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const selectedStartDate = useAtomValue(kpiState.selectedStartDate);
  const selectedEndDate = useAtomValue(kpiState.selectedEndDate);

  const selectedWorkpackTypesFilter = useMemo(() => {
    if (selectedWorkpackTypes.length === 0) return undefined;
    return selectedWorkpackTypes;
  }, [selectedWorkpackTypes]);

  const startDate = selectedStartDate
    ? new Intl.DateTimeFormat('en-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(selectedStartDate)
    : undefined;

  const endDate = selectedEndDate
    ? new Intl.DateTimeFormat('en-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(selectedEndDate)
    : undefined;

  const { data } = useGetLogEntryCardsQuery({
    variables: {
      input: {
        structureIds: selectedDeploymentIds,
        timezone: userTimezone,
        startDate: startDate,
        endDate: endDate,
        collectionNames: [COLLECTION_NAMES.WORKPACK, COLLECTION_NAMES.PLATFORM],
        platformId: platformId ?? undefined,
        category: [LogCategory.Worklog, LogCategory.IndirectPobLog, LogCategory.CostLog],
        workpackTypes: selectedWorkpackTypesFilter,
        wbs: selectedWbsFilter,
      },
    },
    skip: !selectedDeploymentIds.length || !platformId,
  });

  const cards = useMemo(() => data?.getLogEntryCards ?? [], [data?.getLogEntryCards]);

  return (
    <Box
      display="grid"
      gap={2}
      width="100%"
      mt={2}
      sx={{
        // Same column width on every row
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
      }}
    >
      {cards.map((card) =>
        card ? (
          <KpiCard
            key={card.key}
            title={card.title ?? ''}
            value={card.value ?? 0}
            icon={getIconNode(card.icon)}
            subtitle={card.subtitle ?? undefined}
            unit={card.unit as SectionUnitsEnum}
            unitPosition={card.unitPosition ?? undefined}
            roundToDecimal={card.roundToDecimal ?? undefined}
            sectionUnit={card.unit as SectionUnitsEnum}
            unitSystem={unitSystem}
          />
        ) : null
      )}
    </Box>
  );
};
